var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    _vm._l(5, function (index) {
      return _c(
        "b-card",
        { key: index, staticClass: "mb-4", attrs: { "bg-variant": "light" } },
        [
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { lg: "1", sm: "12" } },
                [_c("b-skeleton", { attrs: { type: "avatar" } })],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { attrs: { lg: "8", sm: "12" } },
                [
                  _c("b-skeleton", {
                    staticClass: "mb-3",
                    attrs: { width: "20%" },
                  }),
                  _vm._v(" "),
                  _c("b-skeleton", {
                    staticClass: "mb-3 mt-3",
                    attrs: { width: "30%" },
                  }),
                  _vm._v(" "),
                  _c("b-skeleton", {
                    staticClass: "mt-3",
                    attrs: { width: "50%" },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("b-col", { attrs: { lg: "12" } }, [
                _c(
                  "div",
                  { staticClass: "float-right" },
                  [_c("b-skeleton", { attrs: { type: "button" } })],
                  1
                ),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            { staticClass: "pt-3" },
            [
              _c("b-col", { attrs: { col: "", cols: "12" } }, [
                _c(
                  "div",
                  { staticClass: "btn-group float-right" },
                  [_c("b-skeleton", { attrs: { type: "button" } })],
                  1
                ),
              ]),
            ],
            1
          ),
        ],
        1
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }